import { action } from 'ts-action';

export const breadcrumbsBlur = action('[header] breadcrumbs blur');

export const breadcrumbsSelect = action('[header] breadcrumbs select');

export const menuItemFocus = action('[header] menu item focus');

export const menuItemBlur = action('[header] menu item blur');
